module.exports = __webpack_public_path__ + "img/Subtract-newpic.365d79a6.svg";